import { render, staticRenderFns } from "./OnlinePaymentPolicy.vue?vue&type=template&id=037c97ef&"
import script from "./OnlinePaymentPolicy.vue?vue&type=script&lang=js&"
export * from "./OnlinePaymentPolicy.vue?vue&type=script&lang=js&"
import style0 from "./OnlinePaymentPolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports